import { faEye, faEyeSlash, faPen, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import React, { Component } from 'react';
import MultiSelectDropdown from '../../components/dropdown/MultiSelectDropdown.js';
import ValidationText from '../../utils/validation/ValidationText.js';
import { CommonSuccessMessages, CommonValidationMessages } from '../../utils/Messages.js';
import UtilityServices from '../../services/axioServices/apiServices/UtilityServices.js';
import SwalServices from '../../services/swalServices/SwalServices.js';
import { getAuthProps } from '../../utils/AuthenticationLibrary.js';
import { isValidForm } from '../../utils/validation/CommonValidator.js';

class AdminRole extends Component {
    constructor(props) {
        super(props);
        this.utilityServices = new UtilityServices();
        this.SwalServices = new SwalServices();
        this.state = {
            isGridView: true,
            isEditing: false,
            showPassword: false,
            adminRolesList: [],
            adminList: [],
            adminDetails: {
                _id: "",
                UserName: "",
                email: "",
                Password: "",
                Status: "",
                roleId: 1,
                roles: [],
            },
            filterDetails: {
                UserName: "",
            },
            StatusList: [
                { label: "Active", value: "Active" },
                { label: "In Active", value: "InActive" },
            ],
            validationRules: {
                UserName: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "UserName"
                        ),
                    },
                ],
                email: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "email"
                        ),
                    },
                ],
                Password: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "Password"
                        ),
                    },
                ],
                Status: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "Status"
                        ),
                    },
                ],
                roles: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "roles"
                        ),
                    },
                ],

            },
            validState: {
                isValid: true,
                error: {},
            },
        };
    }

    componentDidMount() {
        let cookies = getAuthProps();
        this.setState({ companyId: cookies.companyId }, () => {
            if (this.state.companyId !== undefined && this.state.companyId !== "") {
                this.getAllAdminsBycompany();
            } else {
                window.location.href = "/Login";
            }
        });

    }
    getAllAdminsBycompany = () => {
        if (this.state.companyId !== undefined && this.state.companyId !== "") {
            let request = this.state.companyId
            this.utilityServices.getAllAdminsByCompanyId(request).then((response) => {
                if (response.statusCode === 200 && response.responseData != null) {
                    response.responseData.forEach((item) => {
                        let roles = item.roles.map((role) => role.roleName).join(", ");
                        item.roles = roles;
                    })
                    this.setState({ adminList: response.responseData }, () => {
                        this.getAllAdminRoles();
                    });
                } else {
                    this.getAllAdminRoles();
                    this.SwalServices.Error(response.Message);
                }
            });
        } else {
            this.SwalServices.Error("Company ID not found.");
        }
    };
    getAllAdminRoles = () => {
        this.utilityServices.getAllAdminRoles().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let adminRolesList = response.responseData.map((item) => ({
                    label: item.roleName,
                    value: item._id,
                }));
                this.setState({ adminRolesList: adminRolesList })
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    };
    getadminById = (id) => {
        this.utilityServices.getadminById(id).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let details = this.state.adminDetails
                details.UserName = response.responseData.UserName
                details.Password = response.responseData.Password
                details.email = response.responseData.email
                details.Status = response.responseData.Status
                details._id = response.responseData._id
                // details.roles = response.responseData.roles.map((role) => role._id)
                if (Array.isArray(response.responseData.roles)) {
                    details.roles = response.responseData.roles.map(role => role._id);
                }
                this.setState({ adminDetails: details, _id: response.responseData._id }, () => {
                    this.setState({ isEditing: true, isGridView: false });
                });
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    };
    addEditAdmin = () => {
        let isValidAllFields = this.isValidAllFields();
        if (isValidAllFields) {
            let request = this.state.adminDetails;
            request.companyId = this.state.companyId;
            if (request._id && request._id !== "") {
            } else {
                delete request._id;
            }
            this.utilityServices.addEditAdmin(request).then((response) => {
                if (response.statusCode === 200 && response.responseData != null) {
                    this.SwalServices.Success(response.Message);
                    this.getAllAdminsBycompany();
                    this.openGridView();
                } else {
                    this.SwalServices.Error(response.Message);
                }
            });
        }
    }

    deleteAdminById = (id) => {
        this.SwalServices.Confirm(
            "",
            ``,
            CommonSuccessMessages.Yes_Text,
            CommonSuccessMessages.No_Text,
            `Are you sure you want to delete this Admin Role?`
        ).then((response) => {
            if (response === true) {
                this.utilityServices.deleteAdminById(id).then((response) => {
                    if (response.statusCode === 200 && response.responseData != null) {
                        this.SwalServices.Success(response.Message);
                        this.getAllAdminsBycompany();
                    } else {
                        this.SwalServices.Error(
                            response.Message
                        );
                    }
                });
            }
        });
    }
    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.adminDetails,
            this.state.validationRules,
            this.state.validState
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    };
    closeGridView = () => {
        this.setState({ isGridView: false, isEditing: false });
    };

    openGridView = () => {
        this.resetForm();
        this.setState({ isGridView: true, isEditing: false }, () => {
            this.getAllAdminsBycompany();
        });
    }
    resetForm = () => {
        let validState = this.state.validState
        validState.isValid = true
        validState.error = {}

        let filterDetails = this.state.filterDetails
        filterDetails.UserName = ""

        let adminDetails = this.state.adminDetails
        adminDetails._id = ""
        adminDetails.UserName = ""
        adminDetails.email = ""
        adminDetails.Password = ""
        adminDetails.Status = ""
        adminDetails.roleId = 1
        adminDetails.roles = []

        this.setState({ filterDetails: filterDetails, adminDetails: adminDetails, validState: validState });
    }
    handleChange = (event, name, section) => {
        let value = event.target.value;
        if (section === "filterDetails") {
            let details = this.state.filterDetails;
            details[name] = value;
            this.setState({ filterDetails: details });
        }

        else if (section === "adminDetails") {
            let details = this.state.adminDetails;
            details[name] = value;
            this.setState({ adminDetails: details });
        }
    };
    handleDropDownChange = (event, name, section) => {
        const select = event.target.value;
        let details = this.state.adminDetails;
        details[name] = select;
        this.setState({ adminDetails: details });

    };
    // setFilterParameters = (selected, drpIdentity) => {
    //     let details = this.state.adminDetails;
    //     details[drpIdentity] = selected.map(option => option.value);
    //     this.setState({ adminDetails: details });
    // };

    setFilterParameters = (selected, drpIdentity) => {
        const details = { ...this.state.adminDetails };
        const selectedValues = Array.isArray(selected)
            ? selected.map((option) => option.value)
            : [];
        details[drpIdentity] = selectedValues;
        this.setState({ adminDetails: details });
    };
    render() {
        return (
            <div className="adminRole">
                {this.state.isGridView === true ? (
                    <>



                        {/* 2. Item tabel  */}
                        <button className="add-btn mb-[16px]" onClick={() => this.closeGridView()}>
                            Add New
                        </button>
                        <div className="itemList-table">
                            <div className="table-container" style={{ height: "calc(100vh - 105px)" }}>
                                <table className="itemList">
                                    <thead>
                                        <tr>
                                            <td className='w-[7%]'>Sr No.</td>
                                            <td className='w-[20%]'>User Name</td>
                                            <td className='w-[20%]'>Email</td>
                                            <td className='w-[13%]'>Status</td>
                                            <td className='w-[25%]'>Roles</td>
                                            <td className="w-[15%] !text-center" style={{ textAlign: "center" }}>Action</td>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {this.state.adminList && this.state.adminList.length > 0 ? (
                                            this.state.adminList.map((item, key) => (
                                                <tr key={key}>
                                                    <td>{key + 1}</td>
                                                    <td>{item.UserName}</td>
                                                    <td>{item.email}</td>
                                                    <td>{item.Status}</td>
                                                    <td>{item.roles}</td>
                                                    <td className='!text-center'>
                                                        <button
                                                            className="search-btn"
                                                            onClick={() => this.getadminById(item._id)}
                                                        >
                                                            <FontAwesomeIcon icon={faPen} />
                                                        </button>
                                                        <button
                                                            className="cancel-btn"
                                                            onClick={() => this.deleteAdminById(item._id)}
                                                        >
                                                            <FontAwesomeIcon icon={faTrash} />
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : this.state.adminList
                                            && this.state.adminList.length === 0
                                            && this.state.noItemFound !== "" ? (
                                            <tr>
                                                <td colSpan={6} style={{ textAlign: "center", fontSize: "16px" }}>
                                                    {this.state.noItemFound}
                                                </td>
                                            </tr>
                                        ) : this.state.adminList
                                            && this.state.adminList.length === 0
                                            && this.state.noItemFound === "" ? null : ""}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                      
                    </>
                ) : null}
                {this.state.isGridView === false ? (
                    <div className="item-form ">
                        <div className="form-table">
                            <div className="item-grp !flex !gap-2.5 !mb-3">
                                <div className="input-grp w-full">
                                    <label>User Name</label>
                                    <input
                                        className={`inputFocus ${this.state.validState?.error?.UserName ? "errorInput" : ""}`}
                                        type="text"
                                        id="UserName"
                                        name="UserName"
                                        autocomplete="off"
                                        value={this.state.adminDetails.UserName}
                                        onChange={(event) =>
                                            this.handleChange(event, "UserName", "adminDetails")
                                        }
                                    />
                                </div>
                                <div className="input-grp w-full">
                                    <label>Email</label>
                                    <input
                                        className={`inputFocus ${this.state.validState?.error?.email ? "errorInput" : ""}`}
                                        type="text"
                                        id="email"
                                        name="email"
                                        autoComplete="new-email"
                                        value={this.state.adminDetails.email}
                                        onChange={(event) =>
                                            this.handleChange(event, "email", "adminDetails")
                                        }
                                    />

                                </div>
                                <div className="input-grp w-full relative">
                                    <label>Password</label>
                                    <input
                                        type={this.state.showPassword ? "text" : "password"}
                                        id="Password"
                                        name="Password"
                                        className={`inputFocus ${this.state.validState?.error?.Password ? "errorInput" : ""}`}
                                        autoComplete="new-password"
                                        value={this.state.adminDetails.Password}
                                        onChange={(event) => {
                                            this.handleChange(event, "Password", "adminDetails");
                                        }}
                                        onBlur={() => this.setState({ showPassword: false })}
                                    />
                                    <span

                                        onClick={() => this.setState({ showPassword: !this.state.showPassword })}
                                        className="absolute right-3 cursor-pointer top-[32px]"
                                    >
                                        {this.state.showPassword ? <FontAwesomeIcon icon={faEye} /> : <FontAwesomeIcon icon={faEyeSlash} />}
                                    </span>
                                </div>

                            </div>
                            <div className="item-grp !flex !gap-2.5 !mb-3">
                                <div className="search-grp w-[45%]">
                                    <label>Status</label>
                                    <select
                                        name="Status"
                                        className={` ${this.state.validState?.error?.Status ? "errorInput" : ""}`}
                                        value={this.state.adminDetails.Status
                                            && this.state.adminDetails.Status !== 'Select'
                                            && this.state.StatusList.find(
                                                (party) => party.value === this.state.adminDetails.Status
                                            )?.value}
                                        onChange={(event) =>
                                            this.handleDropDownChange(
                                                event,
                                                "Status",
                                                "adminDetails"
                                            )
                                        }
                                    >
                                        <option>Select</option>
                                        {this.state.StatusList.map((x, key) => (
                                            <option key={key} value={x.value}>
                                                {x.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="input-grp w-full">
                                    <label>Role ID</label>
                                    <MultiSelectDropdown
                                        drpIdentity="roles"
                                        className={` ${this.state.validState?.error?.roles ? "errorInput" : ""}`}
                                        options={this.state.adminRolesList}
                                        closeMenuOnSelect={false}
                                        hideSelectedOptions={false}
                                        allowSelectAll={false}

                                        isMulti={true}
                                        showCheckbox={true}
                                        onChange={(selected) => this.setFilterParameters(selected, "roles")}
                                        // value={this.state.adminRolesList.filter(
                                        //     (party) => party.value === this.state.adminDetails.roles
                                        // )}
                                        value={this.state.adminRolesList.filter(
                                            (role) => role && this.state.adminDetails.roles.includes(role.value)
                                        )}
                                    />

                                </div>

                            </div>


                            <div className="btn-grp mt-5">

                                <button
                                    className="add-btn"
                                    onClick={() => this.addEditAdmin()}
                                >
                                    {this.state.isEditing ? "Save" : "Add"}

                                </button>
                                <button
                                    className="cancel-btn"
                                    onClick={() => this.openGridView()}
                                >
                                    Cancel
                                </button>

                            </div>
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }
}

export default AdminRole;